export default "__VITE_ASSET__DB8Tx5DK__"